export default __webpack_public_path__ + "static/media/overviewVideo.d277ed5a.mp4";